import React from "react";
import { BCMSRecord, DisabledPrompt, useBCMSContext, useModel, useRoute, useStateManager } from "bcms-react";
import { CenterContentContainer, ContentHeaderView, FormContainer, FormRowView, PageContainer, PageContentView } from "components/shared";
import { FormButtonRow } from "components/shared/containers/FormContainer";
import { UIButton, UITextInput } from "components/ui";
import Classes, { User } from "model";

/**
 * @function UserIdPage
 * @return {React.Component}
 * @exported true
 * @description The main component for UserIdPage
 */
export default function UserIdPage(props) { 
    const model = useModel();
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);
    const data = { ...getDefaultData(model), ...props.data ?? {} };
    const ui = { ...getDefaultUI(), ...props.ui ?? {} };

    const controller = (state, setState) => ({
        data: state.data,
        ui: state.ui,
    });

    return (
        <PageContainer state={ { data, ui } } controller={ controller }>
            <PageContent/>
        </PageContainer>
    )
}

export const getDefaultData = (model) => ({
    user: User.init(model.user)
});

export const getDefaultUI = () => ({
// no ui changes for now
});

  function PageContent() {
    const navigate = useRoute();
    const { data } = useStateManager();

    return (
        <PageContentView>
            <CenterContentContainer>
                <ContentHeaderView text="User ID" />
                <p className="user-id-requirements-text">
                    Your user ID and password are used to log in to this site.
                    This page allows you to change your user ID.
                    Your user ID must be between 9 and 26 characters in length and may be made up of letters, numerals, and special characters (~!@#$%^&*()_+-={ }|:;?,./).
                    Your user ID is not case sensitive.
                </p>
                <FormContainer className="small-form-width">
                    <FormRowView text={`Existing User ID: ${ data.user.id }`} />
                    <FormRowView className="set-width" text="New User ID:">
                        <UITextInput />
                    </FormRowView>
                    <FormRowView text="Confirm User ID:">
                        <UITextInput />
                    </FormRowView>
                    <FormButtonRow>
                        <UIButton className="secondary-button" text="Cancel" onClick={() => { navigate("/profile") }} />
                        <DisabledPrompt>
                            <UIButton className="primary-button" text="Update" />
                        </DisabledPrompt>
                    </FormButtonRow>
                </FormContainer>
            </CenterContentContainer>
        </PageContentView>
    )
  }
